<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card header-tag="header" footer-tag="footer">
              <h1>Ordenes de compra</h1>
              <div>
                <b-form>
                  <b-row>
                    <b-col>
                      <label for="monthSelect">Mes</label>
                      <b-form-select
                        id="monthSelect"
                        v-model="selected.month"
                        :plain="true"
                        :options="selectOptions.months"
                        value="Seleccione..."
                      >
                      </b-form-select>
                    </b-col>
                    <b-col>
                      <label for="yearSelect">Año</label>
                      <b-form-select
                        id="yearSelect"
                        v-model="selected.year"
                        :plain="true"
                        :options="selectOptions.years"
                        value="Seleccione..."
                      >
                      </b-form-select>
                    </b-col>
                  </b-row>
                </b-form>
              </div>
              <hr />
              <v-server-table
                :url="url"
                :columns="columns"
                :options="options"
                :theme="theme"
                ref="table"
                id="dataTable"
              >
                <!-- <div slot="beforeLimit">
                  <download-excel
                    class="btn"
                    :fetch="fetchData"
                    :fields="json_fields2"
                    worksheet="Guias"
                    :name="name"
                    :before-generate="startDownload"
                    :before-finish="finishDownload">
                    <b-link>Descargar</b-link>
                  </download-excel>
                </div> -->

                <div class="text-left" slot="order_date" slot-scope="props">
                  {{ props.row.order_date | date_format }}
                </div>

                <div class="text-left" slot="delivery_date" slot-scope="props">
                  {{ props.row.delivery_date | date_format }}
                </div>

                <div class="text-center" slot="actions" slot-scope="props">
                  <a
                    title="Detalle"
                    href="#"
                    @click.prevent="reportModal(props.row)"
                    class="fa fa-lg fa-search text-black-50"
                  ></a
                  >&nbsp;
                </div>
              </v-server-table>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal
      ref="infoModal"
      centered
      size="lg"
      title="Detalle"
      @ok="purchaseOrderDetails = null"
      ok-only
    >
      <div class="text-center">
        <b-spinner v-if="!purchaseOrderDetails" label="Spinning"></b-spinner>
      </div>
      <Report
        v-if="purchaseOrderDetails"
        :purchaseOrderDetails="purchaseOrderDetails"
        :purchaseOrderData="purchaseOrderData"
      ></Report>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import numeral from "numeral";
import locales from "numeral/locales";

import JsonExcel from "vue-json-excel";
import moment from "moment";
import Report from "./Report.vue";

Vue.component("downloadExcel", JsonExcel);

window.axios = require("axios");

Vue.use(ServerTable);
var d = new Date();

export default {
  name: "ListPurchaseOrder",
  components: {
    ServerTable,
    Report
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });
    this.loadYear();
  },
  props: [],
  data() {
    return {
      selected: {
        month: d.getMonth() + 1,
        year: d.getFullYear()
      },
      selectOptions: {
        months: [
          { value: 1, text: "Enero" },
          { value: 2, text: "Febrero" },
          { value: 3, text: "Marzo" },
          { value: 4, text: "Abril" },
          { value: 5, text: "Mayo" },
          { value: 6, text: "Junio" },
          { value: 7, text: "Julio" },
          { value: 8, text: "Agosto" },
          { value: 9, text: "Septiembre" },
          { value: 10, text: "Octubre" },
          { value: 11, text: "Noviembre" },
          { value: 12, text: "Diciembre" }
        ],
        years: []
      },
      purchaseOrderData: null,
      purchaseOrderDetails: null,
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        Numero: "waybill"
      },
      columns: [
        //"id",
        "company",
        "number",
        "order_date",
        "delivery_date",
        // "note",
        "status",
        "actions"
      ],
      data: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        responseAdapter: function(resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        debounce: 700,
        // columnsDropdown: true,
        filterByColumn: true,
        filterable: ["company", "number", "status"],
        headings: {
          //id: "id",
          company: "Proveedor",
          number: "Numero orden de compra",
          order_date: "Fecha del pedido",
          delivery_date: "Fecha de entrega",
          //note: "Nota",
          status: "Estado",
          actions: "Acciones"
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      },
      json_fields2: {
        Numero: "waybill.number",
        Embarque: "shipment.boarding_number",
        Vgm: {
          field: "vgm",
          callback: value => {
            return numeral(parseFloat(value)).format("0.00");
          }
        },
        "Planilla SAG": "sag_sheet",
        "Contraparte SAG": "sag_worker.get_full_name"
      }
    };
  },
  filters: {
    date_format(value) {
      return moment(value).format("DD-MM-YYYY");
    }
  },
  computed: {
    url() {
      return (
        "/api/v1/current-purchase-order/?" +
        "&month=" +
        this.selected.month +
        "&year=" +
        this.selected.year
      );
    },
    name() {
      return (
        "GuiasExportacion " +
        moment(Date.now()).format("YYYYMMDD h:mm") +
        ".xls"
      );
    }
  },
  methods: {
    closeModal() {
      this.$refs.modalEstiba.hide();
    },
    reportModal(row) {
      console.log("%o", row);
      this.$refs.infoModal.show();
      this.purchaseOrderData = row;
      this.$axios
        .get("/api/supplies/purchase-order/report_detail/?" + "id=" + row.id)
        .then(res => {
          this.purchaseOrderDetails = res.data.data;
        })
        .catch(error => console.log(error));
    },
    async fetchData() {
      const response = await this.$axios.get(
        "/api/comex/export_waybill/detailed/"
      );

      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },

    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Packing List - Guia #" + a + ".xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    downloadWithAxios(a, b) {
      this.$axios({
        method: "get",
        url: "/api/comex/export_waybill/" + a + "/packing_list/",
        responseType: "arraybuffer"
      })
        .then(response => {
          this.forceFileDownload(response, b);
        })
        .catch(() => console.log("error occured"));
    },
    status(shipment_status) {
      return shipment_status === 2 ? "DESPACHADO" : "ABIERTO";
    },
    getBadge(shipment_status) {
      return shipment_status === 2 ? "dark" : "light";
    },
    loadYear() {
      for (let ano = 2017; ano <= d.getFullYear(); ano++) {
        this.selectOptions.years.push({ value: ano, text: ano });
      }
    },
    edit(row) {},
    onComplete() {}
  },
  beforeMount() {}
};
</script>

<style lang="scss">
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }

  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
    padding: 0.25rem;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
